/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Perm_CommunityInputs */

const en_team_perm_community = /** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const es_team_perm_community = /** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const fr_team_perm_community = /** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté`)
};

const de_team_perm_community = /** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const id_team_perm_community = /** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas`)
};

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const ja_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const zh_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const ar_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const it_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const ru_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const pt_team_perm_community = en_team_perm_community;

/** @type {(inputs: Team_Perm_CommunityInputs) => LocalizedString} */
const ko_team_perm_community = en_team_perm_community;

/**
* | output |
* | --- |
* | "Community" |
*
* @param {Team_Perm_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_perm_community = /** @type {((inputs?: Team_Perm_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Perm_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_perm_community(inputs)
	if (locale === "es") return es_team_perm_community(inputs)
	if (locale === "fr") return fr_team_perm_community(inputs)
	if (locale === "de") return de_team_perm_community(inputs)
	if (locale === "ja") return ja_team_perm_community(inputs)
	if (locale === "zh") return zh_team_perm_community(inputs)
	if (locale === "ar") return ar_team_perm_community(inputs)
	if (locale === "id") return id_team_perm_community(inputs)
	if (locale === "it") return it_team_perm_community(inputs)
	if (locale === "ru") return ru_team_perm_community(inputs)
	if (locale === "pt") return pt_team_perm_community(inputs)
	return ko_team_perm_community(inputs)
});